import { getField, updateField } from "vuex-map-fields";
import suppStore from "./suppStore";
import pushNotiStup from "./pushNotiStup";
const getDefaultState = () => {
  return {};
};

const customer = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      // commit("userGuideMotp/resetState");
    },
  },
  modules: {
    suppStore,
    pushNotiStup
  },
};

export default customer;
